<script setup>
import { useGlobalStore } from '@stores/global'
import { useStoreStore } from '@stores/store'

import CartItem from '@components/cart/CartItem.vue'
import Button from '@components/global/button.vue'

const global = useGlobalStore()
const store = useStoreStore()

const checkout = () => {
	window.location.href = store.cart?.checkoutURL
}
</script>

<template>
	<div class="fixed right-0 top-0 isolate z-[1000] flex h-full w-full select-none justify-end">
		<div class="overlay fixed left-0 top-0 -z-10 hidden h-full w-full bg-black/75 md:block" @click="global.toggleCart(false)" />
		<div class="inner bg-bg text-default relative z-10 flex h-full w-full flex-col bg-white md:max-w-md 2xl:max-w-xl">
			<div class="flex items-center justify-between border-b border-border p-2 md:p-4">
				<div class="flex w-full items-center justify-between text-2xl">
					<span class="font-extrabold">Your Cart ({{ store.cart?.totalQuantity ?? 0 }})</span>

					<Button class="btn icon" icon="fa-solid fa-xmark" @click="global.toggleCart(false)" />
				</div>
			</div>
			<div class="relative h-full flex-1 overflow-y-auto">
				<Transition name="fade">
					<div class="bg-bg absolute flex h-full w-full items-center justify-center gap-4" v-if="store.cartLoading">
						<i class="fa-solid fa-spinner-third animate-spin text-lg" />
						<p class="animate-pulse font-bold text-sm uppercase tracking-widest">Processing</p>
					</div>
				</Transition>
				<div class="my-10 flex grow items-center justify-center gap-4" v-if="!store.cart.products?.length">
					<p class="font-bold text-sm uppercase tracking-widest">Your cart is empty</p>
				</div>
				<div class="flex flex-1 grow flex-col gap-5 overflow-y-auto p-5" v-else>
					<CartItem v-for="product in store.cart.products" :key="product.slug" :product="product" />
				</div>
			</div>
			<div class="flex flex-col gap-5 border-t border-border p-4">
				<div class="flex items-center justify-between font-bold text-base">
					<p>Subtotal</p>
					<i class="fa-solid fa-spinner-third animate-spin" v-if="store.cartLoading"></i>
					<p v-else>{{ store.cart.cost?.subtotal ?? '$0.00' }}</p>
				</div>

				<p class="text-sm text-primaryLight">Taxes & shipping calculated at checkout</p>

				<Button :disabled="store.cartLoading || !store.cart.products?.length" @click="checkout" class="primary" :label="store.cartLoading ? 'Please Wait' : 'Go to Checkout'"></Button>
			</div>
		</div>
	</div>
</template>

<style scoped>
.btn.icon {
	@apply text-2xl;
}
</style>
